module.exports = __webpack_public_path__ + "static/img/roaring-bear-b.6bb313a3.svg";